"use client"

import { Lock, Fingerprint, Activity } from "lucide-react"
import { useTranslations } from "next-intl"

const featureIcons = [Lock, Fingerprint, Activity]
const featureKeys = ["secureApi", "minimalAccess", "traceability"] as const

export function InfrastructureSection() {
  const t = useTranslations("techLab.infrastructure")
  
  return (
    <section className="py-24">
      {/* Section header */}
      <div className="text-center mb-16">
        <p className="text-slate-400 text-sm font-medium uppercase tracking-widest mb-3">
          {t("sectionLabel")}
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
          {t("title")}
        </h2>
        <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed">
          {t("subtitle")}
        </p>
      </div>

      {/* Features grid */}
      <div className="grid md:grid-cols-3 gap-8">
        {featureKeys.map((key, idx) => {
          const Icon = featureIcons[idx]
          return (
            <div 
              key={idx}
              className="text-center p-8 rounded-2xl bg-card/30 border border-border/50 hover:border-slate-400/30 transition-colors"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-slate-400/10 border border-slate-400/20 mb-6">
                <Icon className="w-7 h-7 text-slate-400" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                {t(`features.${key}.title`)}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {t(`features.${key}.description`)}
              </p>
            </div>
          )
        })}
      </div>

      {/* Technical detail */}
      <div className="mt-16 p-8 rounded-2xl bg-card/30 border border-border/50">
        <h4 className="font-bold text-foreground mb-4">{t("strictMode.title")}</h4>
        <p className="text-muted-foreground leading-relaxed">
          {t("strictMode.description")}
        </p>
      </div>
    </section>
  )
}
